import { Container, styled } from "@mui/material";

const TabContainer = styled(Container)({
  flexGrow: 1,
  width: "90vw",
  height: "100%",
  display: "flex",
  padding: 0,
});

export default TabContainer;
